import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from './assets/Logo02.png';
import logo2 from './assets/Logo01.png';

import './Header.css';

function Header() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [mainDropdownOpen, setMainDropdownOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode !== null ? JSON.parse(savedMode) : true;
  });

  const mainDropdownRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef(null);

  // Listen for theme changes from other components
  useEffect(() => {
    const handleThemeChange = (event) => {
      setDarkMode(event.detail.darkMode);
    };

    window.addEventListener('themeChange', handleThemeChange);

    return () => {
      window.removeEventListener('themeChange', handleThemeChange);
    };
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (mainDropdownRef.current && !mainDropdownRef.current.contains(event.target)) {
        setMainDropdownOpen(false);
      }
      // Close mobile menu when clicking outside
      if (toggleMenu && menuRef.current && !menuRef.current.contains(event.target) && 
          !event.target.classList.contains('hamburger-button')) {
        setToggleMenu(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [toggleMenu]);

  // Close mobile menu on navigation
  useEffect(() => {
    setToggleMenu(false);
  }, [location]);

  const handleNavigation = (event, targetPath, sectionId = null) => {
    event.preventDefault();
    setMainDropdownOpen(false); // Close dropdown after clicking
    setToggleMenu(false); // Close mobile menu

    if (location.pathname === targetPath) {
      if (sectionId) {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(targetPath);
      if (sectionId) {
        setTimeout(() => {
          document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  };

  const toggleMainDropdown = (e) => {
    e.preventDefault();
    setMainDropdownOpen(!mainDropdownOpen);
  };

  return (
    <header className={`hheader ${darkMode ? '' : 'light-mode'}`}>
      {/* Main Menu Dropdown - Desktop */}
      <div className="main-menu-dropdown" ref={mainDropdownRef}>
        <button 
          className={`menu-toggle-button ${darkMode ? '' : 'light-mode'}`}
          onClick={toggleMainDropdown}
          aria-label="Toggle main menu"
        >
          <div className={`hamburger-icon ${mainDropdownOpen ? 'open' : ''}`}>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
          </div>
          <span>Menu</span>
        </button>

        {/* Main Dropdown Menu */}
        {mainDropdownOpen && (
          <div className={`main-dropdown-menu ${darkMode ? 'dark-mode' : ''}`}>
            <ul className="dropdown-nav-list">
              <li className="dropdown-nav-item">
                <a href="/elimika" target="_blank" rel="noopener noreferrer" onClick={() => setMainDropdownOpen(false)}>
                  Courses
                </a>
              </li>
              <li className="dropdown-nav-item">
                <a href="/shop" target="_blank" rel="noopener noreferrer" onClick={() => setMainDropdownOpen(false)}>
                  Shop
                </a>
              </li>
              <li className="dropdown-nav-item">
                <a href="/bff" target="_blank" rel="noopener noreferrer" onClick={() => setMainDropdownOpen(false)}>
                  BFF
                </a>
              </li>
              <li className="dropdown-nav-item">
                <a href="/nimeahidi" target="_blank" rel="noopener noreferrer" onClick={() => setMainDropdownOpen(false)}>
                  Nimeahidi
                </a>
              </li>
            </ul>
            <div className="dropdown-signup">
              <a href="/signup" onClick={() => setMainDropdownOpen(false)}>
                Sign Up
              </a>
            </div>
          </div>
        )}
      </div>

      {/* Logo - On the right */}
      <div className="hlogo">
        <a href="/">
          <img 
            src={darkMode ? logo : logo2} 
            alt="Sarafrika Logo" 
            className="logo-image" 
          />
        </a>
      </div>

      {/* Mobile Menu Button */}
      <div className="mobile-menu-container">
        <button 
          className={`hamburger-button ${darkMode ? '' : 'light-mode'}`} 
          onClick={() => setToggleMenu(!toggleMenu)}
          aria-label="Toggle menu"
        >
          {toggleMenu ? <RiCloseLine size={27} /> : <RiMenu3Line size={27} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {toggleMenu && (
        <div className={`mobile-menu ${darkMode ? '' : 'light-mode'}`} ref={menuRef}>
          <ul className="mobile-nav-list">
            <li className="mobile-nav-item">
              <a href="/elimika" target="_blank" rel="noopener noreferrer">Courses</a>
            </li>
            <li className="mobile-nav-item">
              <a href="/shop" target="_blank" rel="noopener noreferrer">Shop</a>
            </li>
            <li className="mobile-nav-item">
              <a href="/bff" target="_blank" rel="noopener noreferrer">BFF</a>
            </li>
            <li className="mobile-nav-item">
              <a href="/nimeahidi" target="_blank" rel="noopener noreferrer">Nimeahidi</a>
            </li>
            <li className="mobile-nav-item signup-mobile">
              <a href="/signup">Sign Up</a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default Header;